
import HeroContact from '../../components/HeroComponents/HeroContact'
import Team from "../../components/Team";
import Testimonial from "../../components/Testimonial";
import Projects from "../../components/Projects";
import Newletter from "../../components/Newletter";
import Service from "../../components/Service";
import Facts from "../../components/Facts";
import About from "../../components/About";
import Feature from "../../components/Feature";
import ContactForm from '../../components/ContactForm';

function Contact() {
  return (
    <>
     <HeroContact />
     <ContactForm />

    </>
  )
}

export default Contact